





















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch,
  Mixins
} from "vue-property-decorator";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
@Component({
  components: {
    ImgFetched
  }
})
export default class NormalNotice extends Vue {
  @Prop()
  private effect: any;
  @Prop()
  private icon: any;
  @Prop()
  private text: any;
  @Prop()
  private iconClass: any;
  @Prop()
  private cub: any;

  @Emit("clickOk")
  private clickOk() {
    //
  }
}
